import { useForm } from 'react-hook-form';
import { FlexCenter } from '../Flex';
import TextField from '../TextField';
import Dialog from '../Dialog';

type Props = {
  open: boolean;
  value: string[];
  handleItemClick: (value: string) => void;
  onCloseModal: () => void;
  propertyLabel: string;
};

const FilterChipModal = ({
  open,
  value,
  handleItemClick,
  onCloseModal,
  propertyLabel,
}: Props) => {
  const { register, watch, resetField } = useForm<any>();

  const currValue = watch('containsField');

  return (
    <Dialog
      open={open}
      title={`Filter ${propertyLabel}`}
      confirmText="Apply"
      confirmDisabled={!currValue}
      onClose={() => {
        onCloseModal();
        resetField('containsField');
      }}
      onConfirmButtonClick={() => {
        handleItemClick(currValue);
        onCloseModal();
      }}
      message={
        <FlexCenter>
          <TextField
            fullWidth
            label="Value"
            {...register('containsField', {})}
            variant="outlined"
            placeholder="value"
            defaultValue={value[0]}
          />
        </FlexCenter>
      }
    />
  );
};

export default FilterChipModal;
